var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifeLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 24,
    viewBox: "0 0 117 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6546_2981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.884 0.6073H114.286V0.814206H113.699V2.4222H113.473V0.814206H112.884V0.6073Z",
    fill: "#F2EEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.436 0.6073H114.721L115.365 2.1144L115.999 0.6073H116.28V2.4222H116.059V0.991737L115.458 2.4222H115.259L114.657 0.991737V2.4222H114.436V0.6073Z",
    fill: "#F2EEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.3808V0.5H2.22233V16.3373H10.3709V18.3808H0Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5688 5.35336H16.9189V3.89735C16.9189 1.59839 17.8896 0.5 20.3162 0.5H22.6918V2.4158H20.444C19.3967 2.4158 19.0135 2.85005 19.0135 3.84626V5.35336H22.6918V7.26916H19.0135V18.3808H16.9189V7.26916H14.5688V5.35336Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4785 11.8671C22.4785 7.90774 24.9818 5.20007 28.6602 5.20007C32.3385 5.20007 34.7396 7.52458 34.8418 11.3817C34.8418 11.6627 34.8163 11.9692 34.7907 12.2758H24.6753V12.4546C24.7519 14.9323 26.3101 16.6693 28.7879 16.6693C30.627 16.6693 32.0575 15.6987 32.4918 14.0127H34.6119C34.101 16.6182 31.9553 18.534 28.9411 18.534C25.0329 18.534 22.4785 15.8519 22.4785 11.8671ZM32.5939 10.5388C32.3896 8.2909 30.8569 7.03924 28.6857 7.03924C26.7699 7.03924 25.0074 8.41862 24.803 10.5388H32.5939Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9253 0.5H57.7433V2.54352H51.9461V18.3808H49.7238V2.54352H43.9253V0.5Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0627 10.8708V18.3808H79.9681V10.9986C79.9681 8.44416 78.8441 7.11587 76.8772 7.11587C74.706 7.11587 73.3777 8.75069 73.3777 11.4073V18.3808H71.2831V10.9986C71.2831 8.44416 70.1336 7.11587 68.1412 7.11587C65.9955 7.11587 64.6928 8.90395 64.6928 11.5094V18.3808H62.5981V5.35334H64.4118L64.6928 7.14142C65.3824 6.19629 66.4808 5.20007 68.4988 5.20007C70.3124 5.20007 71.8706 6.01748 72.6114 7.67784C73.4033 6.27292 74.8082 5.20007 77.1327 5.20007C79.8403 5.20007 82.0627 6.75826 82.0627 10.8708Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7364 11.1263V18.3808H96.6418V11.254C96.6418 8.54634 95.3902 7.11587 93.1168 7.11587C90.6645 7.11587 89.183 8.9295 89.183 11.8671V18.3808H87.0884V5.35334H88.902L89.183 7.11587C89.9493 6.11966 91.2776 5.20007 93.4744 5.20007C96.4119 5.20007 98.7364 6.80934 98.7364 11.1263Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.971 5.35334H112.785V17.7422C112.785 21.4971 110.792 23.6428 106.322 23.6428C103.001 23.6428 100.677 22.0847 100.345 19.2237H102.49C102.848 20.8585 104.304 21.7781 106.475 21.7781C109.208 21.7781 110.69 20.5009 110.69 17.6655V16.1329C109.821 17.6145 108.416 18.534 106.22 18.534C102.618 18.534 99.9614 16.1074 99.9614 11.8671C99.9614 7.88219 102.618 5.20007 106.22 5.20007C108.416 5.20007 109.873 6.1452 110.69 7.60121L110.971 5.35334ZM110.715 11.9181C110.715 9.05722 108.978 7.06479 106.424 7.06479C103.87 7.06479 102.107 9.03167 102.107 11.8671C102.107 14.7024 103.844 16.6693 106.424 16.6693C109.004 16.6693 110.715 14.7024 110.715 11.9181Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6185 5.35333H83.5239V18.3808H85.6185V5.35333Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0883 2.01731C86.0883 2.85516 85.4089 3.53463 84.571 3.53463C83.7332 3.53463 83.0537 2.85516 83.0537 2.01731C83.0537 1.17947 83.7319 0.5 84.571 0.5C85.4101 0.5 86.0883 1.17947 86.0883 2.01731Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2045 5.35333H59.1099V18.3808H61.2045V5.35333Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6748 2.01731C61.6748 2.85516 60.9953 3.53463 60.1574 3.53463C59.3196 3.53463 58.6401 2.85516 58.6401 2.01731C58.6401 1.17947 59.3196 0.5 60.1574 0.5C60.9953 0.5 61.6748 1.17947 61.6748 2.01731Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5092 5.35333H11.4146V18.3808H13.5092V5.35333Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.979 2.01731C13.979 2.85516 13.2995 3.53463 12.4616 3.53463C11.6238 3.53463 10.9443 2.85516 10.9443 2.01731C10.9443 1.17947 11.6225 0.5 12.4616 0.5C13.3008 0.5 13.979 1.17947 13.979 2.01731Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8974 6.87449C40.8974 7.71233 40.2179 8.3918 39.3801 8.3918C38.5423 8.3918 37.8628 7.71233 37.8628 6.87449C37.8628 6.03665 38.5423 5.35718 39.3801 5.35718C40.2179 5.35718 40.8974 6.03665 40.8974 6.87449Z",
    fill: "#FB7B34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8974 16.995C40.8974 17.8329 40.2179 18.5123 39.3801 18.5123C38.5423 18.5123 37.8628 17.8329 37.8628 16.995C37.8628 16.1572 38.5423 15.4777 39.3801 15.4777C40.2179 15.4777 40.8974 16.1572 40.8974 16.995Z",
    fill: "#FB7B34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6546_2981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116.28,
    height: 23.1429,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeLogoDark);
export default __webpack_public_path__ + "static/media/life-logo-dark.8db36fdc75a036019347f870291724a1.svg";
export { ForwardRef as ReactComponent };